import Vue from 'vue'
import Vuex from 'vuex'
import Settings from '@/store/modules/Settings.js'
import Page from '@/store/modules/Page.js'
import Media from '@/store/modules/Media.js'
import Category from '@/store/modules/Category.js'
import Navigation from '@/store/modules/Navigation.js'
import Slider from '@/store/modules/Slider.js'
import User from '@/store/modules/User.js'
import Type from '@/store/modules/Type.js'

Vue.use(Vuex)
export const store = new Vuex.Store({
  modules: {
    Settings,
    Page,
    Media,
    Category,
    Navigation,
    Slider,
    User,
    Type
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js